<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="AppActiveUser.id" id="page-user-view">
    <div id="user-data" v-if="serviceRequest">
      <vx-card title="Service Request:" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">HospitalReport S.N:</td>
                <td>{{ serviceRequest.ventilator.serialNumber }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Manufacturer</td>
                <td>{{ serviceRequest.ventilator.manufacturer }}</td>
              </tr>
              <tr>
                <td class="font-semibold">HospitalReport Model</td>
                <td>{{ serviceRequest.ventilator.model }}</td>
              </tr>
              <tr>
                <td class="font-semibold">HospitalReport Type</td>
                <td>{{ serviceRequest.ventilator.type }}</td>
              </tr>
            </table>
          </div>

          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Request Status:</td>
                <td>{{ serviceRequest.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Request Priority:</td>
                <td>{{ serviceRequest.priority }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Work Required:</td>
                <td>{{ serviceRequest.workRequired }}</td>
              </tr>
              <tr v-if="serviceRequest.assigneeUser">
                <td class="font-semibold">Assignee:</td>
                <td>{{ serviceRequest.assigneeUser.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Creator:</td>
                <td>{{ serviceRequest.creatorUser.name }}</td>
              </tr>
            </table>
          </div>

          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              @click="openUpdateServiceRequestModal"
              >Edit</vs-button
            >
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              class="mr-4"
              @click="deleteServiceRequest"
              >Delete</vs-button
            >

            <Prompt
              ref="deleteServiceRequestPrompt"
              accept-text="Delete Service Request"
              color="danger"
              text="You are about to delete this Servoce Request. This cannot be undone."
              title="Confirm Delete Service Request:"
              @confirm="confirmDeleteServiceRequest"
            />
            <UpdateServiceRequestModal
              ref="updateServiceRequestModal"
              :service-request="serviceRequest"
            />
          </div>
        </div>
      </vx-card>
      <NoteList :service-request="serviceRequest" :note-list="noteList" />
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      color="#7367F0"
    />
  </div>
</template>

<script>
import NoteList from "@/modules/note/components/NoteList";
import Loading from "vue-loading-overlay";
import Prompt from "@/components/general-components/modal/Prompt";
import { mapState } from "vuex";
import { ServiceRequest } from "../class-definitions/serviceRequest";
import { SUBSCRIBE_SERVICE_REQUEST_BY_PK } from "../graphql/FetchServiceRequestByPk";
import { SUBSCRIBE_NOTE_LIST_BY_SERVICE_REQUEST_ID } from "@/modules/note/graphql/FetchNoteListByServiceRequestId";
import { filterServiceRequestSubscription } from "../utilities/serviceRequestHelpers";
import UpdateServiceRequestModal from "@/modules/service-request/components/UpdateServiceRequestModal";
import { filterNoteListSubscription } from "@/modules/note/utilities/noteListHelpers";

export default {
  name: "ServiceRequestView",
  components: {
    NoteList,
    UpdateServiceRequestModal,
    Loading,
    Prompt
  },
  data() {
    return {
      serviceRequest: new ServiceRequest(),
      loading: true,
      noteList: []
    };
  },
  computed: {
    ...mapState(["AppActiveUser"])
  },
  apollo: {
    $subscribe: {
      serviceRequest: {
        query: SUBSCRIBE_SERVICE_REQUEST_BY_PK,
        variables() {
          return {
            id: this.$route.params.id
          };
        },
        result(subscription) {
          this.serviceRequest = filterServiceRequestSubscription(subscription);
          this.loading = false;
        }
      },
      noteList: {
        query: SUBSCRIBE_NOTE_LIST_BY_SERVICE_REQUEST_ID,
        variables() {
          return {
            serviceRequest_id: this.$route.params.id
          };
        },
        result(subscription) {
          this.noteList = filterNoteListSubscription(subscription);
        }
      }
    }
  },
  methods: {
    deleteServiceRequest() {
      this.$refs.deleteServiceRequestPrompt.open();
    },
    confirmDeleteServiceRequest() {
      this.serviceRequest
        .delete()
        .then(() => {
          this.showDeleteSuccess();
          this.$router.push(`/servicerequests`);
        })
        .catch(error => {
          console.error(error);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Service Request Deleted:",
        text: "The selected Service Request was successfully deleted"
      });
    },
    openUpdateServiceRequestModal() {
      this.$refs.updateServiceRequestModal.open();
    }
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
.chip {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  font-weight: 500;
}
</style>
